import { render } from "./JobScmStatusBadge.vue?vue&type=template&id=2826f1f6&ts=true"
import script from "./JobScmStatusBadge.vue?vue&type=script&lang=ts"
export * from "./JobScmStatusBadge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__